var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2834.65 2834.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .cls-6 {\n      fill: #636466;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1417.32,2820c226.44,0,410-29.25,410-65.34s-183.56-65.34-410-65.34-410,29.25-410,65.34,183.56,65.34,410,65.34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomShadow);
export default __webpack_public_path__ + "static/media/bottom_shadow.0481e7bcc74f7b8126591f4a44ccc9b3.svg";
export { ForwardRef as ReactComponent };